import { render, staticRenderFns } from "./ChangeTracking.vue?vue&type=template&id=f324e85e&"
import script from "./ChangeTracking.vue?vue&type=script&lang=js&"
export * from "./ChangeTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports